import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { MenuService } from 'src/app/shared/services/menu.service';
declare var dataLayer;
@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss'],
})
export class FilterDialogComponent implements OnInit {
  userType: string;
  userId: any;
  tierType: any;
  constructor(
    private dialogRef2: MatDialogRef<MatDialog>,
    private menuService: MenuService,
    public dialogRef: MatDialogRef<FilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonFunction: CommonFunctions
  ) {
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    this.selectedCoffeeTags = this.data['filtertSelTags'];
    this.data['subCategoriesMenuList'].map((res) => {
      res['click'] = false;
      if (res.filtersData != null) {
        res.filtersData.map((item) => {
          if (this.data['filtertSelTags'].length != 0) {
            if (this.data['filtertSelTags'].includes(item['tag'])) {
              item['click'] = true;
            } else {
              item['click'] = false;
            }
          } else {
            item['click'] = false;
          }
        });
      }
    });
  }
  public list = [
    {
      category: 'Espresso',
      tags: ['Hot coffee', 'Cold Coffe', 'Iced', 'Brewed'],
      tagsTypes: [
        {
          name: 'Hot coffee',
          value: 'Hot coffee',
          category: 'Espresso',
          click: false,
        },
        {
          name: 'Cold Coffe',
          value: 'Cold Coffe',
          category: 'Espresso',
          click: false,
        },
        {
          name: 'Iced',
          value: 'Iced',
          category: 'Espresso',
          click: false,
        },
        {
          name: 'Brewed',
          value: 'Brewed',
          category: 'Espresso',
          click: false,
        },
        {
          name: 'Milky',
          value: 'Milky',
          category: 'Espresso',
          click: false,
        },
        {
          name: 'Chocklate',
          value: 'Chocklate',
          category: 'Espresso',
          click: false,
        },
      ],
    },
  ];
  public selectedCoffeeTags = [];
  selectedItem(item) {
    if (item['click'] == false) {
      this.selectedCoffeeTags.push(item['tag']);
      item['click'] = true;
      this.sendData(this.selectedCoffeeTags);
      this.data['subCategoriesMenuList'].map((res) => {
        if (res.filtersData != null) {
          res.filtersData.map((data) => {
            if (data['tag'] == item['tag']) {
              data['click'] = true;
            }
          });
        }
      });
    } else if (item['click'] == true) {
      this.selectedCoffeeTags.splice(
        this.selectedCoffeeTags.indexOf(item['tag']),
        1
      );
      item['click'] = false;
      this.sendData(this.selectedCoffeeTags);
      this.data['subCategoriesMenuList'].map((res) => {
        if (res.filtersData != null) {
          res.filtersData.map((data) => {
            if (data['tag'] == item['tag']) {
              data['click'] = false;
            }
          });
        }
      });
    }
  }
  sendData(selectedCoffeeTags) {
    this.menuService.sendFilterTags(selectedCoffeeTags);
  }
  setTodefault() {
    this.data['subCategoriesMenuList'].map((res) => {
      if (res.filtersData != null) {
        res.filtersData.map((data) => {
          data['click'] = false;
          this.selectedCoffeeTags = [];
          this.sendData(this.selectedCoffeeTags);
        });
      }
    });
  }
  closeSheet() {
     this.dialogRef.close(this.selectedCoffeeTags) ;
  }
  onCloseClick(): void {
    let obj = {
      buttonName: 'CANCEL',
      tableData: [],
      totalCount: [],
    };
    this.dialogRef.close();
  }
  crossBtnGA(){
    dataLayer.push({
      'event':'cross_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType
    })
  }
}
